var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie-charts"},[_c('Chart',{attrs:{"cdata":_vm.cdata}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }